import React, { FC, useContext } from 'react';
import { ButtonIcon, TertiaryButton } from '@hz-design-system/web-ui';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { FaqReportingContext } from '../context/FaqReportingContext';
import EnvironmentContext from '@/client/contexts/EnvironmentContext';

interface ReportButtonProps {}

const ReportButton: FC<ReportButtonProps> = () => {
  const {
    userDetails: { isLoggedIn },
  } = useContext(EnvironmentContext);
  const { t } = useI18nContext();
  const { setModalOpen } = useContext(FaqReportingContext);

  const handleClick = () => {
    if (isLoggedIn) {
      setModalOpen(true);
      return;
    }

    (() => {
      if (typeof window !== 'undefined') {
        window.location.assign(
          `/account/login.html?target=${encodeURIComponent(`${window.location.href}#report-faq`)}`,
        );
      }
    })();
  };

  return (
    <TertiaryButton onClick={() => handleClick()} aria-label={t('seo.faqReporting.reportButton')}>
      <ButtonIcon name="alert" />
      <Trans i18nKey="seo.faqReporting.reportButton" tagName="span" />
    </TertiaryButton>
  );
};

export default ReportButton;
